import { z } from "zod";
import { ValidationMethods } from "../../utility/validationMethods";
export var ITEM_COMMENT_MAX_LENGTH = 40;
export var itemCommentSchema = z.object({
    comment: z
        .string()
        .max(ITEM_COMMENT_MAX_LENGTH, "Item comments must be ".concat(ITEM_COMMENT_MAX_LENGTH, " characters or fewer."))
        .refine(function (value) { return ValidationMethods.isNotEmoji(value); }, "This field does not support emojis."),
});
